import { getPath } from '@/router/common'
const baseUrl = {
  title: '签收登记',
  path: 'qsRegister'
}

export default [
  {
    path: getPath('Index', baseUrl),
    name: 'qsRegister_Index',
    component: () => import(/* webpackChunkName: "qsRegister_Index" */ '@/views/qsRegister/index/index.vue'),
    meta: {
      title: '签收登记'
    }
  },
  {
    path: getPath('qsSingle', baseUrl),
    name: 'qsRegister_qsSingle',
    component: () => import(/* webpackChunkName: "qsRegister_qsSingle" */ '@/views/qsRegister/qsSingle/index.vue'),
    meta: {
      title: '签收登记-签收库存'
    }
  },
  {
    path: getPath('qsBatch', baseUrl),
    name: 'qsRegister_qsBatch',
    component: () => import(/* webpackChunkName: "qsRegister_qsBatch" */ '@/views/qsRegister/qsBatch/index.vue'),
    meta: {
      title: '签收登记-批量签收'
    }
  },
  {
    path: getPath('qsList', baseUrl),
    name: 'qsRegister_qsList',
    component: () => import(/* webpackChunkName: "qsRegister_qsList" */ '@/views/qsRegister/qsList/index.vue'),
    meta: {
      title: '签收单'
    }
  },
  {
    path: getPath('SatisfactionInvestigation', baseUrl),
    name: 'qsRegister_SatisfactionInvestigation',
    component: () => import(/* webpackChunkName: "qsRegister_SatisfactionInvestigation" */ '@/views/qsRegister/satisfactionInvestigation/index.vue'),
    meta: {
      title: '满意度调查'
    }
  },
  {
    path: getPath('Prescription', baseUrl),
    name: 'qsRegister_Prescription',
    component: () => import(/* webpackChunkName: "qsRegister_Prescription" */ '@/views/qsRegister/prescription/index.vue'),
    meta: {
      title: '时效管理'
    }
  }
]
